<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Etiquetas">
        <b-card-body>

          <b-row>
            <b-col cols="auto" class="mr-auto">
                <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
              -->
                <b-button variant="pinterest" class="mr-1 btn-brand" @click="openMissingModal(null)" :disabled="items.length<=0"><i class="fa fa-ticket"></i><span>Etiquetas Faltantes</span></b-button>
                <b-button variant="reddit" class="mr-1 btn-brand" @click="exportMissingExcel(0, 0, 0)"><i class="fa fa-file-excel-o"></i><span>Exportar Faltantes</span></b-button>
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <!--
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;

              
                -->
                <b-button variant="twitter" class="mr-1 btn-brand" @click="exportExcel(null)"><i class="fa fa-file-excel-o"></i><span>Exportar CSV</span></b-button>
                <b-button variant="github" class="mr-1 btn-brand" @click="openCancelModal()"><i class="fa fa-window-close-o"></i><span>Etiqueta em Branco</span></b-button>

              </b-form-group>
            </b-col>
          </b-row>
              
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    @change="changeCompany"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="inventory" style="font-size: 0.8em">Inventário</label>
                  <b-form-select id="inventory"
                    v-model="filters.inventoryId"
                    :plain="true"
                    :options="inventoryDDL"
                    @change="changeInventory"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="sector" style="font-size: 0.8em">Setor</label>
                  <b-form-select id="sector"
                    v-model="filters.sectorId"
                    :plain="true"
                    :options="selectSectorDDL"
                    :value="[null,'c']">
                </b-form-select>
                 
              </b-form-group>
            </b-col>
            
          </b-row>

          <b-row>
           

            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Etiqueta</label>
                  <b-form-input v-model="filters.label" type="text" id="labelFilter" placeholder="Etiqueta"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>

            <!--
            <b-col cols="auto">
              <b-form-group>
                  <label for="productType" style="font-size: 0.8em">Tipo</label>
                  <b-form-select id="productTypeId"
                    v-model="filters.productTypeId"
                    :plain="true"
                    :options="selectProductTypeDDL"
                    :value="[null,'c']">
                  </b-form-select>

                  {{ filters.productTypeId  }}
              </b-form-group>
            </b-col>
-->

         

            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Operação</label>
                  <b-form-select id="operation"
                    v-model="filters.operationId"
                    :plain="true"
                    :options="selectOperationDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

        
            <b-col cols="auto">
              <b-form-group>
                  <label for="inventoryProductStatus" style="font-size: 0.8em">Status</label>
                  <b-form-select id="inventoryProductStatus"
                    v-model="filters.inventoryProductStatusId"
                    :plain="true"
                    :options="selectInventoryProductStatusDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <!--
          <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Ativo/Inativo</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>
-->
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>

          <b-row class="mb-3">
            <b-col>
              <div class="d-flex align-items-center">
                <span class="text-muted">
                  <strong>Total:</strong> {{ items.length }} etiquetas
                  <span v-if="filteredItems.length !== items.length"> | <strong>Filtrados:</strong> {{ filteredItems.length }}</span>
                </span>
                <b-spinner small variant="primary" class="ml-2" v-if="isLoadingMore"></b-spinner>
                <span v-if="isLoadingMore" class="text-primary ml-1" style="font-size: 0.9em">Carregando mais...</span>
              </div>
            </b-col>
          </b-row>

            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped

                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">

                  

                    <b-card>


                        <b-row v-if="row.item.identificationUser">
                            <b-col class="small col-auto">Identificação: </b-col>
                            <b-col class="text-primary">[{{ row.item.identificationUser.username }}] {{ row.item.identificationUser.name }}</b-col>
                            <b-col class="small col-auto">Data: </b-col>
                            <b-col class="text-primary">{{ $utils.localDateTime(row.item.identificationDate) }}</b-col>
                            <b-col class="small col-auto">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b-col>
                            <b-col class="text-primary">&nbsp;&nbsp;&nbsp;</b-col>
                        </b-row>
                        <b-row v-show="row.item.user1" v-if="row.item.user1">
                            <b-col class="small col-auto">1ª Contagem: </b-col>
                            <b-col class="text-primary">[{{ row.item.user1.username }}] {{ row.item.user1.name }}</b-col>
                            <b-col class="small col-auto">Data: </b-col>
                            <b-col class="text-primary">{{ $utils.localDateTime(row.item.count1Date) }}</b-col>
                            <b-col class="small col-auto">Quantidade: </b-col>
                            <b-col class="text-primary">{{ row.item.count1 }}</b-col>
                        </b-row>
                        <b-row v-show="row.item.user2" v-if="row.item.user2">
                            <b-col class="small col-auto">2ª Contagem: </b-col>
                            <b-col class="text-primary">[{{ row.item.user2.username }}] {{ row.item.user2.name }}</b-col>
                            <b-col class="small col-auto">Data: </b-col>
                            <b-col class="text-primary">{{ $utils.localDateTime(row.item.count2Date) }}</b-col>
                            <b-col class="small col-auto">Quantidade: </b-col>
                            <b-col class="text-primary">{{ row.item.count2 }}</b-col>
                        </b-row>
                        <b-row v-show="row.item.user3" v-if="row.item.user3">
                            <b-col class="small col-auto">Fiscal:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b-col>
                            <b-col class="text-primary">[{{ row.item.user3.username }}] {{ row.item.user3.name }}</b-col>
                            <b-col class="small col-auto">Data: </b-col>
                            <b-col class="text-primary">{{ $utils.localDateTime(row.item.count3Date) }}</b-col>
                            <b-col class="small col-auto">Quantidade: </b-col>
                            <b-col class="text-primary">{{ row.item.count3 }}</b-col>
                        </b-row>
                         <b-row v-show="row.item.modifiedByUser" v-if="row.item.modifiedByUser">
                            <b-col class="small col-auto">Cancelado/Branco:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b-col>
                            <b-col class="text-primary">[{{ row.item.modifiedByUser.username }}] {{ row.item.modifiedByUser.name }}</b-col>
                            <b-col class="small col-auto">Data: </b-col>
                            <b-col class="text-primary">{{ $utils.localDateTime(row.item.modifiedIn) }}</b-col>
                        </b-row>
                        
                    </b-card>
                </template>
                
                <template v-slot:cell(originalValue)="data">
                    {{ !isNaN(data.item.originalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.originalValue) : '' }}
                </template>

                <template v-slot:cell(paymentValue)="data">
                    {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
                </template>

                <template v-slot:cell(productDetail)="data">
                  <div v-if="data.item.product">
                    {{ data.item.product.code  }}<br><span class="text-primary">{{ data.item.product.description }}</span>
                  </div>
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>

                <template v-slot:cell(action)="data">
                      <b-button size="sm" variant="primary" @click.stop="openAdminEditModal(data.item)" class="mr-1 btn-brand" title="Editar (Administrador)" style="margin-bottom: 4px" v-if="isAdmin">
                      <i class="fa fa-edit"></i></b-button>

                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
     <b-modal
              v-model="cancelModal"
              id="cancel-modal"
              centered
              hide-footer
              title="Etiqueta em Branco (Não Utilizado)"
              size="lg">

        <b-card>

         
          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Etiqueta"
                label-for="label"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="label1" id="label" type="number"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description="Não é necessário preencher caso seja apenas 1 etiqueta"
                label="Etiqueta final"
                label-for="label2"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="label2" id="label2" type="number"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          <b-input-group class="mb-4">
            <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>


          Observação: Somente etiquetas não identificadas serão criadas como em branco.

        
          <div slot="footer" class="text-right">
            <b-button variant="html5" class="mr-1 btn-brand" @click="closeCancelModal()"><i class="fa fa-close"></i><span>Fechar</span></b-button>
              <b-button variant="github" class="mr-1 btn-brand" @click="cancelLabel()" :disabled="!(label1 && label1.length > 0)"><i class="fa fa-save"></i><span>Salvar Etiquetas em Branco</span></b-button>
          </div>
        </b-card>

     </b-modal>
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Etiqueta"
              size="lg">

              
          <b-nav fill>  
            <b-nav-item :active="tabInfo=='L'" @click="tabInfo='L'">Etiqueta</b-nav-item>
            <b-nav-item :active="tabInfo=='H'" @click="tabInfo='H'">Histórico</b-nav-item>            
          </b-nav>
          
          <div v-show="tabInfo=='H'">
            <b-card style="min-height: 300px">


              <b-table :items="historyItems" :fields="historyTable.fields" :select-mode="historyTable.selectMode" responsive="sm" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left 
              per-page="50" current-page="1" :busy="historyTable.isBusy" hover striped>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Carregando...</strong>
                  </div>
                </template>
                              
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                                      <span aria-hidden="true">&check;</span>
                                      <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                
                <template v-slot:cell(createdIn)="data">
                    {{ $utils.localDateTime( data.item.createdIn ) }}
                </template>
                              
              </b-table>
              
              
              <b-input-group class="mb-4">
                      <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
              </b-input-group>
            
              <div slot="footer" class="text-right">
                 <b-button variant="html5" class="mr-1 btn-brand" @click="closeEditModal()"><i class="fa fa-close"></i><span>Fechar</span></b-button>
              </div>
              
            </b-card>
          </div>


          <div v-show="tabInfo=='L'">

            <b-card>

              <b-form @submit.stop.prevent="onSubmit">
  
                <div class="animated fadeIn">


              <b-row>
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="Etiqueta"
                        label-for="label"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="selectedItem.label" id="label" type="text" style="text-transform: uppercase" :disabled="!isAdminEdit" ></b-form-input>
                      </b-form-group>
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row v-if="isAdminEdit">
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description="Informe o código do produto e pressione Tab/Enter para localizar"
                        label="Código do Produto"
                        label-for="adminProductCode"
                        :label-cols="3"
                        :horizontal="true">
                        <b-input-group>
                          <b-form-input v-model="adminProductCode" id="adminProductCode" type="text" @blur="getAdminProduct(adminProductCode)"></b-form-input>
                          <b-input-group-append>
                            <b-button variant="primary" @click="getAdminProduct(adminProductCode)"><i class="fa fa-search"></i> Localizar Item</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row v-if="selectedItem.product">
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="Tipo"
                        label-for="typeName"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="selectedItem.product.typeName" id="typeName" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row v-if="selectedItem.product">
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="Código"
                        label-for="itemCode"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="selectedItem.product.code" id="itemCode" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row v-if="selectedItem.product">
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="Item"
                        label-for="itemDescription"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="selectedItem.product.description" id="itemDescription" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row v-if="selectedItem.product">
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="U/M"
                        label-for="itemUM"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="selectedItem.product.umName" id="itemUM" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>



                  <b-row>
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="Setor"
                        label-for="sectorName"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-select v-if="isAdminEdit" id="sectorName" v-model="selectedItem.locationId" :plain="true" :options="sectorDDL"></b-form-select>
                        <b-form-input v-else v-model="selectedItem.locationName" id="sectorName" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                      </b-form-group>
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="Operação"
                        label-for="operationCode"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-select v-if="isAdminEdit" id="operationCode" v-model="selectedItem.operationId" :plain="true" :options="selectOperationDDL"></b-form-select>
                        <b-form-input v-else v-model="selectedItem.operationName" id="operationCode" type="text" style="text-transform: uppercase" disabled ></b-form-input>
                      </b-form-group>
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row v-if="isAdminEdit">
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="Status"
                        label-for="adminStatusId"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-select id="adminStatusId" v-model="selectedItem.statusId" :plain="true" :options="inventoryProductStatusDDL"></b-form-select>
                      </b-form-group>
                      </b-form>
                    </b-col>
                  </b-row>

                  <hr>

                  <b-row v-if="selectedItem.identificationUser">
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="Identificação"
                        label-for="idname"
                        :label-cols="3"
                        :horizontal="true">
                        <b-row>
                          <b-col><b-form-input v-model="selectedItem.identificationUser.name" id="idname" type="text" disabled></b-form-input></b-col>
                          <b-col>{{ selectedItem.identificationDate ? $utils.localDateTime(selectedItem.identificationDate) : '' }}</b-col>
                        </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <hr>

                  <b-row>
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="1ª Contagem"
                        label-for="count1"
                        :label-cols="3"
                        :horizontal="true">
                        <b-row>
                          <b-col><b-form-input v-model="selectedItem.count1" id="count1" type="number" :disabled="!isAdminEdit" ></b-form-input></b-col>
                          <b-col><b-form-input v-model="selectedItem.user1.name" id="count1name" type="text" disabled></b-form-input></b-col>
                          <b-col>{{ selectedItem.count1Date ? $utils.localDateTime(selectedItem.count1Date) : '' }}</b-col>
                        </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="2ª Contagem"
                        label-for="count2"
                        :label-cols="3"
                        :horizontal="true">
                        <b-row>
                          <b-col><b-form-input v-model="selectedItem.count2" id="count2" type="number" :disabled="!isAdminEdit" ></b-form-input></b-col>
                          <b-col><b-form-input v-model="selectedItem.user2.name" id="count2name" type="text" disabled></b-form-input></b-col>
                          <b-col>{{ selectedItem.count2Date ? $utils.localDateTime(selectedItem.count2Date) : '' }}</b-col>
                        </b-row>
                        
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="Fiscal"
                        label-for="count1"
                        :label-cols="3"
                        :horizontal="true">
                        <b-row>
                          <b-col><b-form-input v-model="selectedItem.count3" id="count3" type="number" :disabled="!isAdminEdit" ></b-form-input></b-col>
                          <b-col><b-form-input v-model="selectedItem.user3.name" id="count3name" type="text" disabled></b-form-input></b-col>
                          <b-col>{{ selectedItem.count3Date ? $utils.localDateTime(selectedItem.count3Date) : '' }}</b-col>
                        </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row v-if="selectedItem.modifiedByUser">
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="Cancelado/Branco"
                        label-for="count1"
                        :label-cols="3"
                        :horizontal="true">
                        <b-row>
                          <b-col><b-form-input v-model="selectedItem.modifiedByUser.name" id="modifiedByName" type="text"  ></b-form-input></b-col>
                          <b-col>{{ selectedItem.modifiedIn  }}</b-col>
                        </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>



                  <b-input-group class="mb-4">
                      <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
                  </b-input-group>
                
                  <div slot="footer" class="text-right">
                    <!--
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                   
                  <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Etiqueta</span></b-button>  
                  -->
                    <b-button variant="html5" class="mr-1 btn-brand" @click="openDeleteModal()" v-show="this.selectedItem.statusId != 2"><i class="fa fa-times"></i><span>Cancelar Etiqueta</span></b-button>
                    <b-button variant="github" class="mr-1 btn-brand" @click="saveAdminEdit()" v-show="isAdminEdit"><i class="fa fa-save"></i><span>Salvar Alterações</span></b-button>
                    <b-button variant="github" class="mr-1 btn-brand" @click="closeEditModal()"><i class="fa fa-close"></i><span>Fechar</span></b-button>
                  
                  </div>
                        
                </div>
                </b-form>
                
            </b-card>
          </div>
  
      </b-modal>
  

      <b-modal
              v-model="deleteModal"
              id="delete-modal"
              centered
              hide-footer
              title="Cancelar Etiqueta"
              size="md">

              <b-card>

                <h3>Deseja realmente cancelar a etiqueta {{ this.selectedItem.label }}?</h3>
                <div slot="footer" class="text-right">
                    <!--
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                   
                  <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Etiqueta</span></b-button>  
                  -->
                    <b-button variant="github" class="mr-1 btn-brand" @click="closeDeleteModal()"><i class="fa fa-times"></i><span>Voltar</span></b-button>
                    <b-button variant="html5" class="mr-1 btn-brand" @click="deleteLabel()"><i class="fa fa-close"></i><span>Confirmar Cancelamento</span></b-button>
                  
                  </div>

              </b-card>
              
            

        </b-modal>

        <b-modal
              v-model="missingModal"
              id="missing-modal"
              centered
              hide-footer
              title="Etiquetas Faltantes"
              size="xl">

              <b-card>
                
                <b-row>
                  <b-col cols="auto">
                    <b-form-group>
                        <label for="name" style="font-size: 0.8em">Setor</label>
                        <b-form-select id="missingSector"
                          v-model="missingSectorId"
                          :plain="true"
                          :options="selectSectorDDL"
                          @change="changeMissingSector"
                          :value="[null,'c']">
                        </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="auto" v-show="missingSectorId > 0 && missingRange != ''">
                    <b-form-group>
                        <label for="name" style="font-size: 0.8em">Faixas de Etiqueta</label>
                        <b-form-input type="text" style="width: 300px" v-model="missingRange" readonly></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="auto" v-show="missingSectorId == 0 || missingRange == ''">
                    <b-form-group>
                        <label for="name" style="font-size: 0.8em">Etiqueta Inicial ({{ missingLimitMin }})</label>
                        <b-form-input v-model="missingMin" type="number" id="missingMin" placeholder="" :min="missingLimitMin" :max="missingLimitMax"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="auto" v-show="missingSectorId == 0 || missingRange == ''">
                    <b-form-group>
                        <label for="name" style="font-size: 0.8em">Etiqueta Final ({{ missingLimitLabel }}/{{ invLabelEnd }})</label>
                        <b-form-input v-model="missingMax" type="number" id="missingMax" placeholder="" :min="missingLimitMin" :max="missingLimitMax"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
                    <b-form-group>
                      <p></p>
                      <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshMissing()"><i class="fa fa-search"></i><span>Filtrar</span></b-button>

                      <b-button variant="reddit" class="mr-1 btn-brand" @click="exportMissingExcel(missingSectorId ? missingSectorId : 0, missingMin ? missingMin : 0, missingMax ? missingMax : 0)"><i class="fa fa-file-excel-o"></i><span>Exportar</span></b-button>

                    </b-form-group>
                  </b-col>
                </b-row>

                <p>
                    <b-button :variant="item.sector ? 'twitter' : 'instagram'" class="mr-1 btn-brand" v-for="item in emptyList" :key="item.label" style="margin-top: 5px;"><span class="small">{{ item.sector }}</span><br>{{ String("00000" + item.label).slice(-5) }}</b-button>
                </p>
                
                <div slot="footer" class="text-right">
                    <b-button variant="github" class="mr-1 btn-close" @click="closeMissingModal()"><i class="fa fa-times"></i><span>&nbsp;&nbsp;&nbsp;&nbsp;OK&nbsp;&nbsp;&nbsp;&nbsp;</span></b-button>
                </div>

              </b-card>
              
            

        </b-modal>


    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {label: null, id: null, name: '', description: '', st: 'A', _rowVariant: '', identificationUser: { name: '', id: null}, user1: { name: '', id: null}, user2: { name: '', id: null}, user3: { name: '', id: null}, product: { typeName: null, typeId: null, code: null, umName: null, name: null, description: null}}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch
    },
    data: () => {
      return {
        invLabelEnd: '-',
        selectedMissingSector: null,
        missingRange: '',
        missingSectorId: 0,

        missingLimitLabel: 1,
        missingLimitMin: 1,
        missingLimitMax: 1,
        missingMin: 1,
        missingMax: 100,

        emptyList: [],
        historyItems: [],
        historyTable: {
          isBusy: false,
          fields: [
            //{ key: 'action', label: '', sortable: false, thStyle: { width: "40px" } },
            { key: 'createdIn', label: 'Data', sortable: true },
            { key: 'history', label: 'Descrição', sortable: true},
          ],
          selectMode: 'single'
        },
        
        label1: null,
        label2: null,
        inventoryDDL: [],
        deleteModal: false,
        missingModal: false,
        cancelModal: false,
        tabInfo: 'L',
        inventoryProductStatusDDL: [],
        productTypeDDL: [],
        sectorDDL: [],
        locationDDL: [],
        sectorLabelDDL: [],
        operationDDL: [],
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        companyDDL: [],

        isBusy: false,
        isLoadingMore: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          companyId: null,
          key: '',
          status: 0,
          sectorId: 0,
          operationId: 0,
          productTypeId: 0,
          inventoryProductStatusId: 0,
          inventoryId: 0,
          label: ''
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        isAdminEdit: false,
        hasAdminAccess: false,
        adminProductCode: '',
        items: [
        ],
        baseFields: [
          {key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
          {key: 'label', label: 'Etiqueta', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
          {key: 'product.typeName', label: 'Tipo', sortable: true, thStyle: { width: "150px" } },
          {key: 'productDetail', label: 'Item', sortable: true},
          {key: 'product.umName', label: 'U/M', sortable: true, class: 'text-center'},
          {key: 'locationName', label: 'Setor', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
          {key: 'operationName', label: 'Op', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
          {key: 'count1', label: '1ª Cont', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
          {key: 'count2', label: '2ª Cont', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
          {key: 'count3', label: 'Fiscal', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
          {key: 'status.name', label: 'Status', sortable: true, thStyle: { width: "150px" }, class: 'text-center' },
          //{ key: 'action', label: '', sortable: false, thStyle: { width: "40px" } },
          //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
          //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          //{key: 'description', label: 'Descrição', sortable: false },
          //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
          //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
          //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    watch: {
      'filters.inventoryId': {
        immediate: true,
        handler(newValue, oldValue) {
          if(newValue !== oldValue) {
            const item = this.inventoryDDL.find(item => item.value == newValue)
            this.invLabelEnd = item ? item.labelEnd : '-'
          }
        }
      },
      filteredItems() {
        var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
        if (this.currentPage > totalPages) {
          this.currentPage = 1;
        }
      },
      perPage() {
        var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
        if (this.currentPage > totalPages) {
          this.currentPage = 1;
        }
      }
    },
    computed: {

      isAdmin() {
        return this.hasAdminAccess
      },

      fields() {
        if(this.isAdmin) {
          return [...this.baseFields, { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }]
        }
        return this.baseFields
      },

      selectInventoryProductStatusDDL: function() {
        var list = [...this.inventoryProductStatusDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        return list
      },

      selectProductTypeDDL: function() {
        var list = [...this.productTypeDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        return list
      },

      selectSectorDDL: function() {
        var list = [...this.sectorDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        return list
      },

      selectOperationDDL: function() {
        var list = [...this.operationDDL]
        list = list.sort((a,b) => (Number(a.text) > Number(b.text)) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        return list
      },

      totalRows: function () { return this.filteredItems.length },
      filteredItems() {
        try {
          var s = this
          return this.items.filter(item => {
            return (s.filters.key == '' || (
                  item.product && (
                  s.$utils.filterString(item.product.code, s.filters.key)
                  || s.$utils.filterString(item.product.description, s.filters.key)
                ) 
                  || (item.user1 && item.user1.username == s.filters.key )
                  || (item.user2 && item.user2.username == s.filters.key )
                  || (item.user3 && item.user3.username == s.filters.key )
                  || (item.identificationUser && item.identificationUser.username == s.filters.key )
                )
                //|| s.$utils.filterString(item.product.typeName, s.filters.key)
                //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                )
                && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status ) 
                && (this.filters.label == '' || (
                this.$utils.filterString(item.label, this.filters.label)
                ) )
                && (this.filters.sectorId==0 || (Number(this.filters.sectorId) == Number(item.locationId)))
                && (this.filters.operationId==0 || (Number(this.filters.operationId) == Number(item.operationId)))
                && (this.filters.inventoryProductStatusId==0 || (Number(this.filters.inventoryProductStatusId) == Number(item.status.id)))
          })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {

      async exportMissingExcel(missingSectorId, labelStart, labelEnd) {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          
          var url = this.$store.state.ws_url + "/inventory/export/missing?exportId=6&companyId=" + s.filters.companyId + "&inventoryId=" + s.filters.inventoryId + "&sectorId=" + missingSectorId + "&labelStart=" + labelStart + "&labelEnd=" + labelEnd + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          await axios.get(
              url
          ).then(function(resp) {

          const blob = new Blob([resp.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'export_missing_' + s.filters.inventoryId + '_' + new Date().toISOString().split('T')[0] + '.csv'
          link.click()
          URL.revokeObjectURL(link.href)
              toast ({
                    type: VueNotifications.types.info,
                    title: 'Exportação',
                    message: 'Exportação de etiquetas faltantes gerada com sucesso.',
                    timeout: 5000
                })
          })            
          .catch(function(error) {
              console.log(error);
              toast ({
                    type: VueNotifications.types.error,
                    title: 'Exportação',
                    message: 'Erro ao exportar.',
                    timeout: 5000
                })
          });
      },

      async exportExcel() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          
          await axios.get(
              this.$store.state.ws_url + "/inventory/export/text?exportId=3&inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {

            const blob = new Blob([resp.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'export_label_' + s.filters.inventoryId + '_' + new Date().toISOString().split('T')[0] + '.csv'
          link.click()
          URL.revokeObjectURL(link.href)

              toast ({
                    type: VueNotifications.types.info,
                    title: 'Exportação',
                    message: 'Exportação de Etiquetas gerada com sucesso.',
                    timeout: 5000
                })
          })            
          .catch(function(error) {
              console.log(error);
              toast ({
                    type: VueNotifications.types.error,
                    title: 'Exportação',
                    message: 'Erro ao exportar.',
                    timeout: 5000
                })
          });
            
      },

      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },

      async deleteLabel() {
        var s = this;
      
        await axios.get(
            this.$store.state.ws_url + "/inventory/product/delete?inventoryProductId=" + s.selectedItem.id + "&label=" + s.selectedItem.label + "&uid=" + this.$store.state.currentUser.id + "&sid=" + this.$store.state.currentUser.sid
        ).then(function(resp) {
            s.closeDeleteModal();
            s.closeEditModal();
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);
            toast ({
                type: VueNotifications.types.warn,
                title: 'Erro',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });
      },

      async sendCancelLabel() {
        var s = this;
        if(!this.label2 || this.label2 == null | this.label2 == '' ) this.label2 = this.label1
      
        await axios.get(
            this.$store.state.ws_url + "/inventory/product/cancel?inventoryId=" + this.filters.inventoryId + "&label=" + this.label1 + "&label2=" + this.label2 + "&uid=" + this.$store.state.currentUser.id + "&sid=" + this.$store.state.currentUser.sid
        ).then(function() {
            s.closeCancelModal();
            s.refreshData();
        }
        ).catch(function (error) {
            toast ({
                type: VueNotifications.types.warn,
                title: 'Erro',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });
      },

     
      cancelLabel() {
        let msgError = [];

        if(!this.label1)
            msgError.push("Etiqueta");

        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

            toast ({
                type: VueNotifications.types.error,
                title: 'Aviso',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
           this.sendCancelLabel();
        }
      },

      async saveItem(currentItem) {

        var s = this;
        var postData = {...currentItem};

        postData["companyId"] = s.filters.companyId
        postData["uid"] = this.$store.state.currentUser.id,
        postData["sid"] = this.$store.state.currentUser.sid

        await axios.post(
            this.$store.state.ws_url + "/stock/location",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);
            toast ({
                type: VueNotifications.types.warn,
                title: 'Erro',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });

    },

    save() {

        let msgError = [];

        if(this.selectedItem.name.length <= 2)
            msgError.push("Sigla");
        
        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

            toast ({
                type: VueNotifications.types.error,
                title: 'Aviso',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
    },

      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },

      closeMissingModal() {
        this.emptyList = []
        this.missingModal = false
      },

      changeMissingSector() {
        if(this.missingSectorId && this.missingSectorId > 0) {
          this.selectedMissingSector =  this.locationDDL.find((element) => element.id == this.missingSectorId);
          this.missingRange = ''
          if(this.selectedMissingSector && this.selectedMissingSector.labels && this.selectedMissingSector.labels.length > 0) {
            var sep = ''
            this.selectedMissingSector.labels.forEach(item => {
              this.missingRange = this.missingRange + sep + item.labelStart + '-' + item.labelEnd
              sep = ', '
             })
          }
        }
        else {
          this.selectedMissingSector = null
        }
        this.refreshMissing()
       
      },

      refreshMissing() {
        this.emptyList = []
        var missingBlockList = []

        var labelEnd = this.invLabelEnd && this.invLabelEnd != '-' ? this.invLabelEnd : 0
        if(labelEnd && labelEnd > 0 && labelEnd < this.missingMax) {
          this.missingMax = labelEnd
        }

        if(this.missingSectorId > 0 && this.selectedMissingSector && this.selectedMissingSector.labels) {
          this.selectedMissingSector.labels.forEach(item => {
            missingBlockList.push({ start: item.labelStart, end: item.labelEnd })
          })          
        }
        else {
          missingBlockList.push({ start: this.missingMin, end: this.missingMax })
        }

        if(missingBlockList && missingBlockList.length > 0) {
          // Pré-computa o conjunto de etiquetas existentes uma única vez (O(n)) em vez de
          // um find() O(n) a cada número candidato do intervalo (era O(intervalo x itens)).
          var existingLabels = new Set(this.items.map(item => parseInt(item.label)))
          var emptyList = []

          missingBlockList.forEach(item => {
            var end = parseInt(item.end)
            for(var c = parseInt(item.start); c <= end; c++) {
              if(!existingLabels.has(c)) {
                var locatedSector = this.sectorLabelDDL.find((sector) => c >= sector.start && c <= sector.end)
                emptyList.push({ label: c, sector: locatedSector ? locatedSector.sector : ''})
              }
            }
          })

          this.emptyList = emptyList
        }
        else {
          console.log("Erro estranho, deveria ter missingBlockList")
        }

        /*
        var c = this.missingMin         
        for(;c <= this.missingMax;c++) {
          if(!this.items.find((element) => parseInt(element.label) === c)) {
            this.emptyList.push({ label: c })
          }
        }
        */
      },

      openMissingModal() {
        if(this.items && this.items.length > 0) {

          const item = this.inventoryDDL.find(item => item.value == this.filters.inventoryId)
          this.invLabelEnd = item ? item.labelEnd : '-'

          this.missingModal = true

          // Um único passo por items para achar min/max, em vez de map()+spread
          // repetido até 3x (custoso e arriscado de estourar a pilha em inventários grandes).
          var minLabel = Infinity
          var maxLabel = -Infinity
          this.items.forEach(item => {
            var label = parseInt(item.label)
            if(label < minLabel) minLabel = label
            if(label > maxLabel) maxLabel = label
          })

          this.missingMin = this.missingLimitMin = minLabel
          if(!this.invLabelEnd || this.invLabelEnd == '-' || this.invLabelEnd <= 0) {
            this.missingLimitLabel = this.missingMax = this.missingLimitMax = maxLabel
          }
          else {
            this.missingLimitLabel = maxLabel
            this.missingMax = this.missingLimitMax = this.invLabelEnd
          }

          this.emptyList = []
        }
        else {
          toast ({
              type: VueNotifications.types.error,
              title: 'Etiquetas Faltantes',
              message: 'Nenhuma etiqueta cadastrada para o inventário.',
              timeout: 3000
          })
        }
      },
     
      closeDeleteModal() {
        this.deleteModal = false
      },

      openDeleteModal() {
        this.deleteModal = true
      },

      closeCancelModal() {
        this.cancelModal = false
      },
      openCancelModal() {
        this.selectedItem = { ...newItem };
        this.cancelModal = true
      },

      closeEditModal() {
        console.log("fechando edição")
        this.editModal = false;
      },

      openEditModal(item) {
        this.isAdminEdit = false

        if(item == null) {
            this.selectedItem = { ...newItem };
            this.historyItems = []
        }
        else {
            this.selectedItem = { ...item };
            this.getHistory(item)
        }

        if(!this.selectedItem.user1) {
          this.selectedItem.user1 = { id: null, name: null, username: null }
        }
        if(!this.selectedItem.user2) {
          this.selectedItem.user2 = { id: null, name: null, username: null }
        }
        if(!this.selectedItem.user3) {
          this.selectedItem.user3 = { id: null, name: null, username: null }
        }

        this.selectedItem.statusId = this.selectedItem.status ? this.selectedItem.status.id : null

        this.tabInfo = 'L'
        this.editModal = true;
      },

      openAdminEditModal(item) {
        this.openEditModal(item)
        this.isAdminEdit = true
        this.adminProductCode = this.selectedItem.product ? this.selectedItem.product.code : ''
      },

      async getAdminProduct(code) {
        if(code && code.length > 2) {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          await axios.get(
              this.$store.state.ws_url + "/product?companyId=" + s.filters.companyId + "&key=" + code + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
              if(resp.data.obj && resp.data.obj.length > 0) {
                s.selectedItem.product = resp.data.obj[0]
                s.selectedItem.productId = resp.data.obj[0].id
              }
              else {
                toast ({
                    type: VueNotifications.types.warn,
                    title: 'Produto',
                    message: 'Produto não encontrado.',
                    timeout: 3000
                })
              }
          })
          .catch(function(error) {
              console.log(error);
          });
        }
      },

      async saveAdminEdit() {
        var s = this;

        if(!this.selectedItem.label || this.selectedItem.label.length <= 0) {
          toast ({
              type: VueNotifications.types.error,
              title: 'Etiqueta',
              message: 'Verifique os campos: Etiqueta',
              timeout: 5000
          })
          return
        }

        var currentUser = this.$store.state.currentUser;
        var postData = {
          id: this.selectedItem.id,
          inventoryId: this.filters.inventoryId,
          label: this.selectedItem.label,
          productId: this.selectedItem.productId,
          locationId: this.selectedItem.locationId,
          operationId: this.selectedItem.operationId,
          statusId: this.selectedItem.statusId,
          count1: this.selectedItem.count1,
          count2: this.selectedItem.count2,
          count3: this.selectedItem.count3,
          notes: this.selectedItem.notes,
          uid: currentUser.id,
          sid: currentUser.sid
        }

        await axios.post(
            this.$store.state.ws_url + "/inventory/product/admin",
            postData
        ).then(function() {
            toast ({
                type: VueNotifications.types.success,
                title: 'Etiqueta',
                message: 'Alterações salvas com sucesso.',
                timeout: 3000
            })
            s.closeEditModal()
            s.refreshData();
        }).catch(function (error) {
            console.log(error);
            toast ({
                type: VueNotifications.types.warn,
                title: 'Erro',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })
        });
      },
      onRowSelected(items) {
        this.selected = items       
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
        if(!this.tableSelectable) {
            this.clearSelectedRows();
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      
      async getOperation() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          await axios.get(
              this.$store.state.ws_url + "/stock/operation/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {
              s.operationDDL = resp.data.obj;
          })            
          .catch(function(error) {
              console.log(error);
          });
          
      }, 
      
      async getProductType() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          await axios.get(
              this.$store.state.ws_url + "/product/type/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {
              s.productTypeDDL = resp.data.obj;
          })            
          .catch(function(error) {
              console.log(error);
          });
          
      }, 

      async getInventoryProductStatus() {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          await axios.get(
              this.$store.state.ws_url + "/inventory/product/status/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {
              s.inventoryProductStatusDDL = resp.data.obj;
          })            
          .catch(function(error) {
              console.log(error);
          });
          
      }, 

      async getHistory(item) {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          
          await axios.get(
              this.$store.state.ws_url + "/inventory/product/history?inventoryProductId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {
              s.historyItems = resp.data.obj;
          })            
          .catch(function(error) {
              s.historyItems = []
              console.log(error);
          });
          
      }, 

      async getSector() {
          var s = this;
          var currentUser = this.$store.state.currentUser

          await axios.get(
              this.$store.state.ws_url + "/stock/location/label/ddl?inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
              s.sectorDDL = resp.data.obj
              s.filters.sectorId = 0
              s.refreshData()
          })
          .catch(function(error) {
              console.log(error);
              s.sectorDDL = []
              s.filters.sectorId = 0
          });
          
      },

      async getInventory() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          
          await axios.get(
              this.$store.state.ws_url + "/stock/inventory/ddl?companyId=" + s.filters.companyId + "&inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {
              //console.log(resp.data.obj)
              s.inventoryDDL = resp.data.obj;

              if(s.inventoryDDL && s.inventoryDDL.length > 0) {
                // Busca último inventoryId se não houver um restaurado/selecionado válido
                if(!s.filters.inventoryId || s.filters.inventoryId <= 0 || !s.inventoryDDL.some(i => i.value == s.filters.inventoryId)) {
                  s.filters.inventoryId = Number(s.inventoryDDL[s.inventoryDDL.length-1].value)
                }
                if(s.filters.inventoryId && s.filters.inventoryId > 0) {
                  const item = s.inventoryDDL.find(item => item.value == s.filters.inventoryId)
                  s.invLabelEnd = item ? item.labelEnd : '-'
                }
              }
              s.$utils.setInventoryContext(s.$store.state.config.storageName, s.filters.companyId, s.filters.inventoryId)
              s.filters.sectorId = 0
              s.getSector()
              s.getLocation()
          })
          .catch(function(error) {
              console.log(error);
              s.inventoryDDL = []
          });
          
      }, 

      async getLocation() {
        var s = this;
        var currentUser = this.$store.state.currentUser;

        await axios.get(
            this.$store.state.ws_url + "/stock/location/inventory?companyId=" + s.filters.companyId + "&inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function (resp) {
            s.locationDDL = resp.data.obj;
            s.sectorLabelDDL = []
            s.locationDDL.forEach((location)=>{
              if(location.labels && location.labels.length > 0) {
                location.labels.forEach((label) => {
                  s.sectorLabelDDL.push({ start: label.labelStart, end: label.labelEnd, sector: location.name })  
                })
              }
              
            })

        }
        ).catch(function (error) {
             console.log(error.message);
        });
      },

      async refreshData() {
        this.isBusy = true;
        this.isLoadingMore = false;

        var s = this;
        var currentUser = this.$store.state.currentUser;
        var page = 0;
        var pageSize = 100;
        var allItems = [];
        var hasMoreData = true;

        while (hasMoreData) {
          var url = this.$store.state.ws_url + "/inventory/product?inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid + "&page=" + page + "&pageSize=" + pageSize;
          try {
            var resp = await axios.get(url);

            if (resp.data.obj && resp.data.obj.length > 0) {
              allItems = allItems.concat(resp.data.obj);

              // Atualiza a tabela com os dados carregados até o momento
              s.items = [...allItems];

              // Remove o loading após carregar a primeira página
              if (page === 0) {
                s.isBusy = false;
                // Se há mais páginas, mostra o spinner de loading adicional
                if (resp.data.obj.length === pageSize) {
                  s.isLoadingMore = true;
                }
              }

              // Se retornou menos itens que o pageSize, não há mais páginas
              if (resp.data.obj.length < pageSize) {
                hasMoreData = false;
              } else {
                page++;
              }
            } else {
              // Sem mais dados
              hasMoreData = false;
            }
          } catch (error) {
            hasMoreData = false;
            toast({
              type: VueNotifications.types.error,
              title: 'Erro',
              message: 'Sem permissão de acesso. Verifique e tente novamente.',
              timeout: 3000
            });
          }
        }

        this.isBusy = false;
        this.isLoadingMore = false;
      },

      changeInventory() {
        this.$utils.setInventoryContext(this.$store.state.config.storageName, this.filters.companyId, this.filters.inventoryId)
        this.getSector()
        this.getLocation()
      },

      changeCompany() {
        this.getOperation()
        this.getProductType()
        this.getInventoryProductStatus()
        this.getInventory()
      },

      async getAdminAccess() {
        var s = this
        var currentUser = this.$store.state.currentUser

        await axios.get(
            this.$store.state.ws_url + "/user/checkaccess?uid=" + currentUser.id + "&sid=" + currentUser.sid + "&accessCode=ADMMASTER"
        ).then(function() {
          s.hasAdminAccess = true
        })
        .catch(function() {
          s.hasAdminAccess = false
        })
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies

      var stored = this.$utils.getInventoryContext(this.$store.state.config.storageName)
      var validStoredCompany = stored && stored.companyId && this.companyDDL.some(c => c.value == stored.companyId)

      this.filters.companyId = validStoredCompany ? stored.companyId : this.$store.state.currentUser.companyId
      if(validStoredCompany && stored.inventoryId) {
        this.filters.inventoryId = stored.inventoryId
      }

      this.getAdminAccess()
      this.changeCompany()
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>